/* global axios */
import ApiClient from '../ApiClient';

class CustomReportsAPI extends ApiClient {
  constructor() {
    super('omni/custom_reports', { accountScoped: true });
  }

  // GET /api/v1/accounts/:account_id/omni/custom_reports
  list() {
    return axios.get(this.url);
  }

  // GET /api/v1/accounts/:account_id/omni/custom_reports/:id
  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  // POST /api/v1/accounts/:account_id/omni/custom_reports
  create(data) {
    return axios.post(this.url, { custom_report: data });
  }

  // PATCH /api/v1/accounts/:account_id/omni/custom_reports/:id
  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { custom_report: data });
  }

  // DELETE /api/v1/accounts/:account_id/omni/custom_reports/:id
  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // POST /api/v1/accounts/:account_id/omni/custom_reports/run
  run(agentBotId, queryConfig) {
    return axios.post(`${this.url}/run`, {
      agent_bot_id: agentBotId,
      query_config: queryConfig,
    });
  }

  // GET /api/v1/accounts/:account_id/omni/custom_reports/metadata?agent_bot_id=
  getMetadata(agentBotId) {
    return axios.get(`${this.url}/metadata`, {
      params: { agent_bot_id: agentBotId },
    });
  }
}

export default new CustomReportsAPI();
